import { format } from 'date-fns';

export const routerPath = {
  root: '/personal-trainers-sales-report',
};

export const getColumns = () => [
  {
    id: 'boughtAt',
    label: 'Bought At',
    align: 'left',
    customValue: (item) => (item.boughtAt ? format(new Date(item.boughtAt), 'yyyy-MM-dd p') : ''),
    nameForSort: 'bought_at',
  },
  {
    id: 'packageName',
    label: 'Package Name',
    align: 'center',
    nameForSort: 'package_name',
  },
  {
    id: 'packageSessionAmount',
    label: 'Package Session Amount',
    align: 'center',
    nameForSort: 'package_session_amount',
  },
  {
    id: 'personalTrainerFullName',
    label: 'PT Full Name',
    align: 'center',
    nameForSort: 'personal_trainer_full_name',
  },
  {
    id: 'userName',
    label: 'User Name',
    align: 'center',
    nameForSort: 'user_name',
  },
  {
    id: 'userSurname',
    label: 'User Surname',
    align: 'center',
    nameForSort: 'user_surname',
  },
  {
    id: 'userPhoneNumber',
    label: 'User Phone Num',
    align: 'center',
    disableSort: 'true',
  },
  {
    id: 'region',
    label: 'Region',
    align: 'center',
    disableSort: 'true',
  },
];

export const getFilters = ({ personalTrainerId, dateRange, options }) => [
  {
    id: 'personalTrainerId',
    type: 'select',
    label: 'Personal Trainer',
    value: personalTrainerId.value,
    action: personalTrainerId.change,
    items: options?.allPersonalTrainers?.length ? ['all', ...options.allPersonalTrainers] : ['all'],
  },
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
];
